import { normalizePositions, toEpochMs } from '../core/track.js';

function responderFrom(event) {
    if (event?.eventType !== 'RESPONDER_UPDATE') return null;
    let value = event.eventData ?? event.value;
    for (let i = 0; i < 3; i += 1) {
        if (typeof value === 'string') {
            try { value = JSON.parse(value); } catch (_) { return null; }
        }
        if (value && typeof value === 'object' && value.userId != null) return value;
        value = value?.value ?? value?.eventData;
    }
    return null;
}

/** Ajoute le canal interne d'alerte à la relecture du rendez-vous. */
export function mergeAlertIntoRendezVous(rdvBundle, alerts = []) {
    if (!rdvBundle) return null;
    const tracks = rdvBundle.tracks.map(track => ({ ...track,
        positions: [...(track.positions || [])], media: [...(track.media || [])] }));
    const events = [...(rdvBundle.events || [])];
    const phases = [];
    const responders = new Map();
    for (const alert of alerts) {
        const startMs = toEpochMs(alert.startedAt ?? alert.startMs);
        const endMs = toEpochMs(alert.endedAt ?? alert.endMs);
        if (startMs === null) continue;
        phases.push({ id: alert.sessionId, sessionId: alert.sessionId, userId: alert.userId,
            startMs, endMs, label: 'Alerte' });
        const owner = tracks.find(track => String(track.userId) === String(alert.userId));
        events.push({ t: startMs, kind: 'alert-start', label: `Alerte déclenchée par ${owner?.label || 'un participant'}`, trackId: owner?.id || null });
        if (endMs !== null) events.push({ t: endMs, kind: 'alert-end', label: 'Alerte arrêtée', trackId: owner?.id || null });
        const loaded = alert.loaded;
        if (!loaded || !owner) continue;
        owner.positions.push(...(loaded.bundle?.tracks?.[0]?.positions || []).filter(point => point.t >= startMs));
        const alertMedia = loaded.bundle?.tracks?.[0]?.media || [];
        owner.media.push(...alertMedia.map(media => ({ ...media, id: `alert-${media.id}`, label: `Alerte — ${owner.label}`,
            startMs: Math.max(startMs, media.startMs ?? startMs),
            endMs: Math.max(startMs, endMs ?? rdvBundle.endMs ?? media.endMs ?? startMs),
            alertMedia: true, mediaKey: loaded.mediaKey, mediaHeaders: loaded.headers })));
        for (const line of loaded.journal || []) {
            if (!Number.isFinite(line.t) || line.t < startMs || line.kind === 'NEWPOSITION') continue;
            events.push({ t: line.t, kind: 'alert-journal', label: line.label, trackId: owner.id });
        }
        for (const event of loaded.events || []) {
            const info = responderFrom(event);
            if (!info || info.userId == null) continue;
            const lat = Number(info.lat ?? info.latitude);
            const lng = Number(info.lng ?? info.longitude);
            if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) continue;
            const id = String(info.userId);
            if (!responders.has(id)) responders.set(id, { id: `responder-${id}`, userId: info.userId,
                kind: 'responder', label: info.userEmail || `Intervenant ${id}`, color: '#22C55E', positions: [], media: [], photos: [] });
            responders.get(id).positions.push({ t: toEpochMs(event.timestamp) ?? startMs, lat, lng, status: info.status || 'ACTIVE' });
        }
    }
    tracks.forEach(track => { track.positions = normalizePositions(track.positions); });
    responders.forEach(track => { track.positions = normalizePositions(track.positions); tracks.push(track); });
    events.sort((a, b) => a.t - b.t);
    const times = [rdvBundle.startMs, rdvBundle.endMs, ...phases.flatMap(p => [p.startMs, p.endMs]),
        ...tracks.flatMap(track => [track.positions[0]?.t, track.positions.at(-1)?.t])].filter(Number.isFinite);
    return { ...rdvBundle, tracks, events, alerts: phases,
        startMs: times.length ? Math.min(...times) : rdvBundle.startMs,
        endMs: times.length ? Math.max(...times) : rdvBundle.endMs };
}
